// PopUpModal.jsx
import React from "react";
import { CrossIcon } from "../assets/icons";

export default function PopUpModal({
  visible,
  onClose,
  title = "Modal Title",
  children,
  onConfirm,
  confirmText = "Create",
  cancelText = "Cancel",
  confirmDisabled = false,
  loading = false,
  size = "medium", // small, medium, large, xlarge
  hideConfirm = false,
}) {
  if (!visible) return null;

  const sizeClasses = {
    small: "max-w-[500px]",
    medium: "max-w-[700px]",
    large: "max-w-[863px]",
    xlarge: "max-w-[1024px]",
  };

  return (
    <div className="fixed m-0 inset-0 flex items-center justify-center z-[999] bg-black/20 backdrop-blur-sm w-full h-full top-0 right-0">
      <div
        className={`bg-white rounded-xl shadow-lg w-full ${sizeClasses[size]} p-8 relative max-h-[90vh] overflow-y-auto`}
      >
        {/* Close Button */}
        <button
          className="w-[40px] h-[40px] bg-[#F6F6F6] absolute top-6 right-6 text-2xl text-gray-400 hover:text-gray-800 rounded-[50%] flex items-center justify-center"
          onClick={onClose}
        >
          {CrossIcon}
        </button>

        {/* Title */}
        <h2 className="ModalTitle mb-6">{title}</h2>

        {/* Dynamic Content */}
        <div className="comman-form">{children}</div>

        {/* Action Buttons */}
        <div className="flex gap-4 justify-end mt-8 pt-6 ">
          <button
            type="button"
            className="btn-light-gray min-w-[140px]"
            onClick={onClose}
            disabled={loading}
          >
            {cancelText}
          </button>
          {!hideConfirm && (
            <button
              type="button"
              className="btn-light-blue min-w-[140px]"
              onClick={onConfirm}
              disabled={confirmDisabled || loading}
            >
              {loading ? "Loading..." : confirmText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
